import React, { FC, useContext, useEffect, useState, memo } from "react";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
import { VisibilityContext } from "../../context";
import { OverflowDetails } from "../../typescript/interfaces/data";

const useStyles = makeStyles({
  overflowContainer: {
    position: "relative",
    height: "41px",
    overflow: "hidden",
  },
  overflowNote: {
    position: "absolute",
    bottom: "0px",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    fontSize: "0.7rem",
    fontStyle: "italic",
    color: "lightslategray",
    cursor: "pointer",
  },
  gutter: {
    margin: "16px 0px",
  },
});

interface OverflowWrapperProps {
  overflow: OverflowDetails;
  rowId: number;
  displayOverflowNote: boolean;
}

const OverflowWrapper: FC<OverflowWrapperProps> = ({ overflow, rowId, displayOverflowNote, children }) => {
  const classes = useStyles();

  const [visibilityContext, setVisibilityContext] = useContext(VisibilityContext);
  const [isOpen, setIsOpen] = useState(false);

  const handleRowExpand = () => {
    const isAlreadyExpanded = visibilityContext.rowsExpanded.includes(rowId);
    setVisibilityContext({
      ...visibilityContext,
      rowsExpanded: isAlreadyExpanded
        ? visibilityContext.rowsExpanded.filter((row) => row !== rowId)
        : [...visibilityContext.rowsExpanded, rowId],
    });
  };

  useEffect(() => {
    visibilityContext.rowsExpanded.includes(rowId) ? setIsOpen(true) : setIsOpen(false);
  }, [visibilityContext.rowsExpanded]);

  useEffect(() => {
    visibilityContext.detailPanelsOpen.includes(rowId) ? setIsOpen(true) : setIsOpen(false);
  }, [visibilityContext.detailPanelsOpen]);

  return (
    <div className={isOpen ? classes.gutter : ""}>
      {overflow.isExpandable && !isOpen ? <div className={classes.overflowContainer}>{children}</div> : <>{children}</>}
      {overflow.isExpandable && displayOverflowNote && (
        <div onClick={() => handleRowExpand()}>
          <Typography variant="body2" className={classes.overflowNote}>
            {isOpen ? "Collapse" : `+${overflow.hiddenRows} More`}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default OverflowWrapper;
